import { useAuth0 } from '@auth0/auth0-react'
import { Grid } from '@mui/material'
import Box from '@mui/material/Box'
import { useContext, useState } from 'react'
import AppContext from '../../context/appContext'
import { useFarm } from '../../hooks/data/useFarm'
import { useFarmSubdivisions } from '../../hooks/data/useFarmSubdivisions'
import { usePaddocksSortedByArea } from '../../hooks/data/usePaddocks'
import AllotmentMap from './AllotmentMap'
import AllotmentPanel from './AllotmentPanel'

// Hoisted so a still-loading query never hands a fresh array identity down: the panel's derivation
// effects and the map's redraw effect key off exactly that.
const NO_FARM_SUBDIVISIONS = []
const NO_PADDOCKS = []

const AllotmentHome = () => {
  const { currentFarm, programConfig } = useContext(AppContext)
  const { user } = useAuth0()

  const { data: farm } = useFarm(currentFarm?.id, user)
  const { data: farmSubdivisionsData } = useFarmSubdivisions({ farmId: currentFarm?.id })
  const { data: paddocksData } = usePaddocksSortedByArea({ farmId: currentFarm?.id })

  const [paddocksFeatures, setPaddocksFeatures] = useState([])
  const [mapAction, setMapAction] = useState(null)
  const [selectedArea, setSelectedArea] = useState()
  const [selectedAreaType, setSelectedAreaType] = useState()
  const [wasSaved, setWasSaved] = useState(false)
  const [drawActivated, setDrawActivated] = useState(false)
  const [selectedYears, setSelectedYears] = useState([])
  // Owned here (not inside AllotmentPanel, which drives the staging workflow) because the map is
  // a sibling that must render the staged lotes as a preview layer.
  const [stagedImportFeatures, setStagedImportFeatures] = useState([])

  const farmSubdivisions = farmSubdivisionsData ?? NO_FARM_SUBDIVISIONS
  const paddocks = paddocksData ?? NO_PADDOCKS

  return (
    <Box>
      <Grid container>
        <Grid item xs={4}>
          <AllotmentPanel
            drawActivated={drawActivated}
            farm={farm}
            farmSubdivisions={farmSubdivisions}
            formDefinitions={programConfig?.formDefinitions}
            mapAction={mapAction}
            paddocks={paddocks}
            paddocksFeatures={paddocksFeatures}
            selectedArea={selectedArea}
            selectedYears={selectedYears}
            setDrawActivated={setDrawActivated}
            setMapAction={setMapAction}
            setPaddocksFeatures={setPaddocksFeatures}
            setSelectedArea={setSelectedArea}
            setSelectedAreaType={setSelectedAreaType}
            setSelectedYears={setSelectedYears}
            setStagedImportFeatures={setStagedImportFeatures}
            setWasSaved={setWasSaved}
            stagedImportFeatures={stagedImportFeatures}
            wasSaved={wasSaved}
            yearsAllowed={programConfig?.farmSubdivisionsYearsAllowed}
          />
        </Grid>
        <Grid item xs={8}>
          <AllotmentMap
            farm={farm}
            mapAction={mapAction}
            paddocksFeatures={paddocksFeatures}
            perimeter={farm?.toGeoJSON}
            selectedArea={selectedArea}
            selectedAreaType={selectedAreaType}
            selectedYears={selectedYears}
            setMapAction={setMapAction}
            setPaddocksFeatures={setPaddocksFeatures}
            stagedFeatures={stagedImportFeatures}
          />
        </Grid>
      </Grid>
    </Box>
  )
}

export default AllotmentHome
